import { cn } from "@/modules/lib/utils"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { BoxLeadDetailsHeader } from "@modules/boxLead/components/boxLeadInfo/boxLeadDetailsHeader"
import { BoxLeadOffersLayout } from "@modules/boxLead/components/boxLeadInfo/boxLeadOffersLayout"
import { BoxLeadOverview } from "@modules/boxLead/components/boxLeadInfo/boxLeadOverview"
import { BoxLeadOverviewSkeleton } from "@modules/boxLead/components/boxLeadInfo/boxLeadOverviewSkeleton"
import { BoxLeadPublicProfil } from "@modules/boxLead/components/boxLeadInfo/boxLeadPublicProfil"
import { BoxLeadTab } from "@modules/boxLead/components/boxLeadInfo/boxLeadTab"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { HuAvatarCardSidebarSkeleton } from "@modules/ui/components/huAvatarCardSidebarSkeleton"
import { Activity, Suspense } from "react"

type BoxLeadDetailsInfoLayoutProps = {
  leadId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadDetailsInfoLayout({ leadId, className, ...props }: BoxLeadDetailsInfoLayoutProps) {
  const { getCurrentStackState } = useSidebar()
  const activeIndex = getCurrentStackState("activeTabIndex") ?? "0"

  return (
    <div className={cn("flex w-full flex-col", className)} {...props}>
      {/* HEADER */}
      <Suspense fallback={<HuAvatarCardSidebarSkeleton />}>
        <BoxLeadDetailsHeader leadId={leadId} />
      </Suspense>

      {/* NAVIGATION TABS */}
      <BoxLeadTab activeIndex={activeIndex} leadId={leadId} />
      {/* OVERVIEW */}
      <Activity mode={activeIndex === "0" ? "visible" : "hidden"}>
        <Suspense fallback={<BoxLeadOverviewSkeleton />}>
          <BoxLeadOverview leadId={leadId} />
        </Suspense>
      </Activity>
      {/* PUBLIC PROFIL */}
      <Activity mode={activeIndex === "1" ? "visible" : "hidden"}>
        <Suspense fallback={<LoadingSpinner className="flex h-min w-full pt-15" />}>
          <BoxLeadPublicProfil leadId={leadId} />
        </Suspense>
      </Activity>
      {/* OFFERS */}
      <Activity mode={activeIndex === "2" ? "visible" : "hidden"}>
        <Suspense fallback={<LoadingSpinner className="flex h-min w-full pt-15" />}>
          <BoxLeadOffersLayout leadId={leadId} />
        </Suspense>
      </Activity>
    </div>
  )
}
